module.exports = __webpack_public_path__ + "img/american-credit-home-slide-8.9038c2d.webp";